/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutboundPlanForScanVo } from './OutboundPlanForScanVo';
import {
    OutboundPlanForScanVoFromJSON,
    OutboundPlanForScanVoFromJSONTyped,
    OutboundPlanForScanVoToJSON,
    OutboundPlanForScanVoToJSONTyped,
} from './OutboundPlanForScanVo';

/**
 * 
 * @export
 * @interface ResponseOutboundPlanForScanVo
 */
export interface ResponseOutboundPlanForScanVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOutboundPlanForScanVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOutboundPlanForScanVo
     */
    message?: string;
    /**
     * 
     * @type {OutboundPlanForScanVo}
     * @memberof ResponseOutboundPlanForScanVo
     */
    data?: OutboundPlanForScanVo;
}

/**
 * Check if a given object implements the ResponseOutboundPlanForScanVo interface.
 */
export function instanceOfResponseOutboundPlanForScanVo(value: object): value is ResponseOutboundPlanForScanVo {
    return true;
}

export function ResponseOutboundPlanForScanVoFromJSON(json: any): ResponseOutboundPlanForScanVo {
    return ResponseOutboundPlanForScanVoFromJSONTyped(json, false);
}

export function ResponseOutboundPlanForScanVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOutboundPlanForScanVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OutboundPlanForScanVoFromJSON(json['data']),
    };
}

export function ResponseOutboundPlanForScanVoToJSON(json: any): ResponseOutboundPlanForScanVo {
    return ResponseOutboundPlanForScanVoToJSONTyped(json, false);
}

export function ResponseOutboundPlanForScanVoToJSONTyped(value?: ResponseOutboundPlanForScanVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OutboundPlanForScanVoToJSON(value['data']),
    };
}

